import companiesCollection from 'modules/core/store/collections/companies'

import { Documents } from 'modules/documents/store/collections/documents'
import { Folders } from 'modules/documents/store/collections/folders'
import {
  ALL_TYPES as FOLDER_TYPES,
  PAYROLL_PAYSLIP_FOLDER_IDENTIFIER,
  PAYROLL_RESULT_FOLDER_IDENTIFIER,
} from 'modules/documents/store/models/Folder'
import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { PayrollDocuments } from 'modules/payroll_bundle/store/collections/payrollDocuments'

export const useFetchUploadedResultData = () => {
  const { resultDispatch } = usePayrollResults()

  const fetch = async (policyPeriodId: number) => {
    const payrollDocuments = new PayrollDocuments()
    const documents = new Documents()
    const folders = new Folders()

    const loadFiles = async () => {
      await payrollDocuments.fetch({
        data: {
          policy_period_ids: [policyPeriodId],
        },
      })

      const documentIds = payrollDocuments.map(
        (payrollDocument) => payrollDocument.attributes.document_id
      )

      if (documentIds.length === 0) {
        // If there are no documents selected, we don't fetch. Otherwise, the documents endpoint
        // will return all the available documents for the Bookkeeper
        documents.reset([])
        return null
      } else {
        await documents.fetch({
          data: {
            ids: documentIds,
          },
        })
      }
    }

    const loadFolders = async () => {
      await folders.fetch({
        data: {
          company_id: companiesCollection.current.id,
          type: FOLDER_TYPES.payroll_company,
        },
      })
    }

    await Promise.all([loadFiles(), loadFolders()])

    const payrollResultsFolderIds = folders
      .filter(
        (folder) =>
          folder.attributes.identifier !== null &&
          PAYROLL_RESULT_FOLDER_IDENTIFIER.includes(folder.attributes.identifier)
      )
      .map((item) => item.id)

    const uploadedPayrollResults = documents.models.filter((document) => {
      const folderId = document.get('folder_id')

      return payrollResultsFolderIds.includes(folderId)
    })

    const payrollPayslipFolderIds = folders
      .filter(
        (folder) =>
          folder.attributes.identifier !== null &&
          PAYROLL_PAYSLIP_FOLDER_IDENTIFIER.includes(folder.attributes.identifier)
      )
      .map((item) => item.id)

    const uploadedPayrollPayslips = documents.models.filter((document) => {
      const folderId = document.get('folder_id')

      return payrollPayslipFolderIds.includes(folderId)
    })

    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        uploadedPayrollResults,
        uploadedPayrollPayslips,
      },
    })
  }

  return { fetch }
}
